import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsNavigationComponent } from '@spartacus/core';
import { CmsComponentData, NavigationService } from '@spartacus/storefront';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'cx-footer-navigation',
    templateUrl: './footer-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenFooterNavigationComponent {

  data$: Observable<any> = this.componentData.data$
    .pipe(
      switchMap(data => combineLatest([
        this.service.getNavigationNode(
          this.componentData.data$
        ),
        of(data)
      ])),
      map(([nodes, data]) => {
        return {
          ...data,
          nodes
        }
      })
    );

  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: NavigationService
  ) {
  }
}
